require('./tabbedBoxContent.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

const TabbedBoxContent = props => {
    const { children, visible } = props;
    const tabContentClassname = classNames('tabbed-box__content', {
        'tabbed-box__content--active': visible
    });

    return (
        <div className={tabContentClassname}>
            {children}
        </div>
    );
};

TabbedBoxContent.propTypes = {
    children: PropTypes.object,
    visible: PropTypes.bool.isRequired,
}

module.exports = TabbedBoxContent;